import { Collapse } from '@bfe/moly';
import React, { FC } from 'react';
import { useI18n } from '@spot-fe/base-ui';
import { Block } from '@/components/Layout';
import { replaceDomainToLocation } from '@spot-fe/utils';
import styles from './index.module.scss';

export const Faq: FC = () => {
  const { t, locale } = useI18n();

  const items = [
    {
      label: t('preMarketTrading'),
      key: 1,
      children: t('preMarketTrdDesc'),
    },
    {
      label: t('completeDelivery'),
      key: 2,
      children: (
        <div style={{ whiteSpace: 'pre-wrap' }}>
          {t('deliveryInstructions')}
        </div>
      ),
    },
    {
      label: t('transactionDelay'),
      key: 3,
      children: t('tokenDeliveryObligation'),
    },
    {
      label: t('tokenListDelay'),
      key: 4,
      children: t('tokenListingDelayInfo'),
    },
    {
      label: t('preMarketAffectInitPrice'),
      key: 5,
      children: t('preMarketVsOfficialPrice'),
    },
  ];

  return (
    <Block bgColor="#000" clsName={styles.faq}>
      <h2 className={styles.heading}>{t('faq')}</h2>
      <Collapse
        items={items}
        collapsible
        moreLink={replaceDomainToLocation(
          `https://www.bybit.com/${locale}/help-center/article/FAQ-Pre-market-Trading`
        )}
        moreText={t('more')}
        className={styles.collapse}
      />
    </Block>
  );
};
